/*
Jitbit TabUtils - helper for multiple browser tabs. version 1.0

https://github.com/jitbit/TabUtils

- executing "interlocked" function call - only once per multiple tabs
- broadcasting a message to all tabs (including the current one) with some message "data"
- handling a broadcasted message

MIT license: https://github.com/jitbit/TabUtils/blob/master/LICENSE
*/

global.printBlock = new (function () {
    this.print = function (divName) {
        const printContents = document.getElementById(divName).innerHTML;
        const originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;

        window.print();

        document.body.innerHTML = originalContents;
    };
})();
